// extracted by mini-css-extract-plugin
export default {"dateCenterCalendarWeek":"date-center-calendar-week_dateCenterCalendarWeek__M80-o"};